export default "__VITE_ASSET__Bk$pA6$l__"